import React, { Component } from 'react'
import './Other.css'
let otherBusinessInterest = 'Details not available'
class Other extends Component {
    constructor(props) {
        super(props)
    }
    componentWillReceiveProps(nextProps){
        otherBusinessInterest=nextProps.transporter_data.other_business_interest;
        if(otherBusinessInterest==undefined || otherBusinessInterest==null){
            otherBusinessInterest='Details not available'
    
        }
    }
    
    render() {
        return (
            <>
            <div className="othercard">
                <div className="othercontainer row">
                    <div className="col-12">
                <h3 className="data_header">Other Business Interest</h3>
                    </div>
                    <div className="col-12">
                   {(otherBusinessInterest)?( <span>{otherBusinessInterest}</span>):(<p>Details not available</p>)}
                    </div>
                </div>
            </div>
            </>
        )
    }
}

export default Other
